// Discrete letter text sizes. Each size pairs a font size with a line
// height; the ruled-paper grid uses the same line height, so bumping the
// size keeps the text sitting on the lines (the line spacing grows with
// the text). Some fonts render visually smaller than others, so a couple
// of taps on the size stepper evens that out.

export type LetterSize = {
  id: string;
  label: string;
  font: number; // px
  line: number; // px — also the ruled-line period + paragraph spacing
};

export const LETTER_SIZES: LetterSize[] = [
  { id: 's', label: 'S', font: 14, line: 24 },
  { id: 'm', label: 'M', font: 16, line: 28 },
  { id: 'l', label: 'L', font: 18, line: 32 },
  { id: 'xl', label: 'XL', font: 21, line: 38 },
];

export const DEFAULT_LETTER_SIZE = LETTER_SIZES[1]; // 'm'

export function getLetterSize(id: string | undefined): LetterSize {
  if (!id) return DEFAULT_LETTER_SIZE;
  return LETTER_SIZES.find((s) => s.id === id) ?? DEFAULT_LETTER_SIZE;
}

export function stepLetterSize(id: string, dir: 1 | -1): LetterSize {
  const i = LETTER_SIZES.findIndex((s) => s.id === id);
  const next = Math.max(0, Math.min(LETTER_SIZES.length - 1, i + dir));
  return LETTER_SIZES[next];
}

/** CSS custom properties that drive font-size, line-height and the rule grid. */
export function sizeVars(size: LetterSize): React.CSSProperties {
  return {
    ['--letter-font' as string]: `${size.font}px`,
    ['--letter-line' as string]: `${size.line}px`,
  };
}
